import { getArticles, getMagazineCategories } from '@shared/api-utils';
import { enrichMagazineArticles, type MagazineArticle } from '../../helpers/magazineCategory';

type GetFeaturedArticlesParams = {
  locale: string;
  limit: number;
};

type FeaturedArticlesResult = {
  latest: MagazineArticle[];
  recommended: MagazineArticle[];
};

// TODO: API does not currently support filtering by recommended articles.
async function getFeaturedArticles(apiUrl: string, { locale, limit }: GetFeaturedArticlesParams): Promise<FeaturedArticlesResult> {
  const [response, categories] = await Promise.all([getArticles(apiUrl, { locale, limit }), getMagazineCategories(apiUrl, locale)]);

  const latest = response.data;
  // TODO: replace with recommended/featured articles once API support is available
  const recommended: MagazineArticle[] = [];

  return {
    latest: enrichMagazineArticles(latest, categories),
    recommended,
  };
}

export { getFeaturedArticles, type FeaturedArticlesResult, type GetFeaturedArticlesParams };
